import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import ProductSearchResult from './productSearchResult';
import ChangeZipCode from '../common/changeZipCode';

import {
	saveNarrowYourResultSelectedValue,
	saveProductLineFilters,
	resetProductNumberKeywordResultList,
	saveProductLine,
	saveProductLineNarrowYourResultsFilters,
	getProductLineNarrorYourResultFilters,
	updateAvailabilityWithPricesAndDiscounts,
	getProductLineFilters,
	resetProductAvailabilityResultList,
	getQuoteModels,
	resetProductPricesResultList,
} from '../../../redux/actions';

import ExportProductPriceInfoOverlayDialog from '../../dialogs/exportProductPriceInfoOverlayDialog';
import SuccessPriceTemplateConfirmation from '../../dialogs/successPriceTemplateConfirmation';

class SearchResult extends Component {

    constructor(props){
        super(props);
        this.state = {
			searchStrQuoteModels: null,
			showSuccessPriceTemplateConfirmation: false,

            errorMessage: "",
            typeOfSearch: "",

			selectedNarrowYourResult: "",
			hideNarrowByFilters: true,
			showFilters: false,
			showExportProductPriceDialog: false,

			navigationState: '',

			getFilters: false,

			noRecordFound: false,
			filteredAvailQty : false,
			filterNLA : true,
        }
		this.fetchProductLineSearchResult = this.fetchProductLineSearchResult.bind(this);
		this.getZipCode = this.getZipCode.bind(this);
		this.handleSelectAvail = this.handleSelectAvail.bind(this);
		this.handleExcludeNla = this.handleExcludeNla.bind(this);
    }

	getZipCode() {
		return this.props.customZipCode;
	}

	clearStoreData = () => {
		this.props.saveProductLineFilters(null);
		this.props.resetProductNumberKeywordResultList();
		this.props.resetProductAvailabilityResultList();
		this.props.resetProductPricesResultList();
	}

	componentWillMount() {
		if (this.props.params.typeOfSearch === 'quote-models' && this.props.state.user.selectedPriceSource['Quote Type'] !== 'Q') {
			browserHistory.push('/home');
		}
		if (this.props.params.typeOfSearch === 'product-line' && this.props.params.searchKeyword) {
			const searchKeyword = decodeURI(this.props.params.searchKeyword).split("|");
			const navigationState = "?" + searchKeyword[1];
			this.setState({
				navigationState, typeOfSearch: this.props.params.typeOfSearch
			})
			if (!this.props.state.product.productLine || !this.props.state.product.productLine.navigationState || this.props.state.product.productLine.navigationState !== navigationState) {
				this.clearStoreData();
			}
		} else if ((this.props.params.typeOfSearch === 'product-number' || this.props.params.typeOfSearch === 'quote-models') && this.props.state.product.productLine) {
			this.clearStoreData();
			this.props.saveProductLine('');
		}
		this.setState({
			filterNLA: this.props.state.product.fromWhere !== "Search_Button"
		});
	}

	componentWillReceiveProps(nextProps) {
		const self = this;
		// update local state with zipcode, this is useful when page is getting refreshed
		if (self.props.customZipCode && nextProps.customZipCode && self.props.customZipCode !== nextProps.customZipCode) {
			self.props.resetProductAvailabilityResultList();
			setTimeout(() => {
				self.setState({
					onlyAvailabilityCall: true
				}, () => {
					if (nextProps.params.typeOfSearch === 'product-line') {
						self.checkAvailabilityAndAll({ useBackup : { items: true, prices: true } });
					} else {
						self.checkAvailabilityAndAll();
					}
				});
			}, 40);
		} else if(
			(self.props.state.user.selectedAddress && self.props.state.user.selectedAddress !== nextProps.state.user.selectedAddress) ||
			(self.props.state.user.selectedADC && self.props.state.user.selectedADC !== nextProps.state.user.selectedADC &&
				nextProps.state.user.selectedPriceSource.AGREEMENT_NUMBER === self.props.state.user.selectedPriceSource.AGREEMENT_NUMBER
			)
		) {
			self.props.resetProductAvailabilityResultList();
			setTimeout(() => {
				self.setState({
					onlyAvailabilityCall: true,
				}, () => {
					if (nextProps.params.typeOfSearch === 'product-line') {
						self.checkAvailabilityAndAll({ useBackup : { items: true, prices: true } });
					} else {
						self.checkAvailabilityAndAll();
					}
				})
			}, 40);
		}
		if(nextProps.state.user.selectedPriceSource.AGREEMENT_NUMBER !== this.props.state.user.selectedPriceSource.AGREEMENT_NUMBER) {
			if(nextProps.params.typeOfSearch === 'quote-models') {
				if (nextProps.state.user.selectedPriceSource['Quote Type'] !== 'Q') {
					browserHistory.push('/home');
				} else {
					self.setState({
						searchStrQuoteModels: null
					}, () => {
						self.props.resetProductAvailabilityResultList();
						self.checkAvailabilityAndAll();
					});
				}
			} else {
				self.fetchSearchResultData(nextProps, true);
			}
		}
		if(nextProps.params.searchKeyword !== self.props.params.searchKeyword) {
			self.setState({
				selectedNarrowYourResult: self.props.state.product.productLine.navigationState,
				typeOfSearch: nextProps.params.typeOfSearch,
				hideNarrowByFilters: true
			});
			//Clear filter first time once user comes first on this page after searching from login page
			self.props.saveProductLineFilters(null);

			if (nextProps.params.typeOfSearch === 'product-number') {
				self.clearStoreData();
				self.props.saveProductLine('');
				self.fetchSearchResultData(nextProps, false);
			} else if (nextProps.params.typeOfSearch === 'product-line') {
				self.clearStoreData();
				const searchKeyword = decodeURI(nextProps.params.searchKeyword).split("|");
				const navigationState = "?" + searchKeyword[1], label = searchKeyword[0];
				self.props.saveProductLine({
					navigationState,
					label
				});
				self.setState({
					filterNLA: true
				})
				self.fetchProductLineSearchResult(navigationState, nextProps.params.typeOfSearch, { updateBackup: { items: true, availability: true, prices: true } });
			}
		}

		if(self.props.params.typeOfSearch !== 'quote-models' && nextProps.params.typeOfSearch === 'quote-models') {
			this.clearStoreData();
			this.props.saveProductLine('');
			self.setState({
				selectedNarrowYourResult: self.props.state.product.productLine.navigationState,
				typeOfSearch: nextProps.params.typeOfSearch,
				hideNarrowByFilters: true,
				searchStrQuoteModels: null
			}, () => {
				self.checkAvailabilityAndAll();
			});
		}
	}

	fetchSearchResultData(nextProps, availabilityAndPricingCallRequired) {
		const self = this;
		const { selectedAccount, selectedPriceSource } = nextProps.state.user;
		self.props.checkAndSetSearchResult(
			nextProps.params.typeOfSearch,
			selectedAccount.ACCOUNTNUMBER,
			selectedPriceSource.AGREEMENT_NUMBER,
			self.getZipCode(),
			decodeURI(nextProps.params.searchKeyword),
			"",
			response => {
				// Check if both (prices and availability) service call are completed or not
				// add prices to availability existing object and update it in to store before redirecting to search result page
				if (this.typeOfSearch === 'product-line') {
					self.props.updateAvailabilityWithPricesAndDiscounts({ updateBackup: { availability: true, prices: true } });
					setTimeout(() => {
						self.updateFilters();
					}, 0);
				} else {
					self.props.updateAvailabilityWithPricesAndDiscounts();
				}
			},
			false,
			availabilityAndPricingCallRequired,
			{
				useBackup: { items: true }
			}
		);
	}

	handleDialogStatus(flag, event) {
		event && event.preventDefault();
        this.setState({
            showExportProductPriceDialog: flag
        });
    }

	handleDialogStatusRunExportConfirm(flag, event) {
		event && event.preventDefault();
        this.setState({
            showSuccessPriceTemplateConfirmation: flag
        });
	}

	handleDialogStatusExport(flag, isEmailSent, event) {
		event && event.preventDefault();
		var self = this;
		if(isEmailSent) {
			self.setState({
				showSuccessPriceTemplateConfirmation: false,
			}, () => {
				self.setState({
					showSuccessPriceTemplateConfirmation: true,
					showExportProductPriceDialog: flag
				});
			});
		} else {
			self.setState({
				showExportProductPriceDialog: flag
			});
		}
    }

    componentDidMount() {
		const self = this;
		const myInt = setInterval(() => {
			const selectedADC = self.props.state.user.selectedADC;
			if (selectedADC) {
				clearInterval(myInt);
				self.checkAvailabilityAndAll();
			}
		}, 50);
    }

	componentDidUpdate(prevProps) {
		const prevProduct = prevProps.state && prevProps.state.product;
    	const currentProduct = this.props.state && this.props.state.product;
		if (prevProps.state.product.fromWhere !== this.props.state.product.fromWhere) {
			this.setState({
				filterNLA: this.props.state.product.fromWhere !== "Search_Button"
			});
		}
		const prevFilters = prevProduct && prevProduct.productLineFilters && prevProduct.productLineFilters.filters;
		const currentFilters = currentProduct && currentProduct.productLineFilters && currentProduct.productLineFilters.filters;

	}
	updateFilters = () => {
		if (this.state.typeOfSearch === 'product-line') {
			this.props.saveProductLineFilters(null);
			const skuList = [];
			this.props.state.product.productResultAvailabilityBackup && this.props.state.product.productResultAvailabilityBackup.forEach((item, index) => {
				skuList.push({
					"sku": item.sku
				});
			});
			skuList.length > 0 && this.props.getProductLineFilters(skuList, this.state.navigationState.replace("?", ""));
		}
	}

	// If useBackup items/prices is true, items/prices data will be used from productNumberKeywordResultBackup/productResultPricesBackup for filtering, this is because
	// when changing ship to address or sales agreement, we are currently ignoring any sub filters and checking the availability/price for all items that were loaded initially when launching the page
	checkAvailabilityAndAll(options = { useBackup: { items: false, prices: false }}) {
		const self = this;
		const typeOfSearch = self.props.params.typeOfSearch;

		self.setState({
			typeOfSearch
		}, () => {
			if(!self.props.state.product.productResultAvailability) {
				const { selectedAccount, selectedPriceSource } = self.props.state.user;
				if(typeOfSearch === 'product-line') {
					const searchKeyword = decodeURI(self.props.params.searchKeyword).split("|");
					const navigationState = "?" + searchKeyword[1],
						label = searchKeyword[0];

					self.setState({
						selectedNarrowYourResult: navigationState
					});

					self.props.saveProductLine({
						navigationState,
						label: label
					});

					this.props.checkAndSetSearchResult(
						'product-line',
						selectedAccount.ACCOUNTNUMBER,
						selectedPriceSource.AGREEMENT_NUMBER,
						self.getZipCode(),
						"",
						navigationState,
						response => {
							// Check if both (prices and availability) service call are completed or not
							// add prices to availability existing object and update it in to store before redirecting to search result page
							const isOnlyAvailabilityCall = self.state.onlyAvailabilityCall;
							self.props.updateAvailabilityWithPricesAndDiscounts({ updateBackup: { items: !options.useBackup.items && !options.useBackup.prices, availability: true, prices: !options.useBackup.prices } });
							!isOnlyAvailabilityCall && self.props.saveProductLineFilters(null);
							self.setState({
								onlyAvailabilityCall: false
							}, () => {
								!isOnlyAvailabilityCall && self.updateFilters();
							});
						},
						self.state.onlyAvailabilityCall,
						false,
						{ useBackup: options.useBackup }
					);
					if(!self.state.onlyAvailabilityCall) {
						//Make parallel call for narrow your result filters
						self.props.saveProductLineNarrowYourResultsFilters(null);
						//get categoryId
						const categoryId = navigationState.replace('?N=','');
						self.props.getProductLineNarrorYourResultFilters("requestType=getProductLine&categoryId="+categoryId);
					}
				} else if (typeOfSearch === 'product-number') {
					self.props.checkAndSetSearchResult(
						'product-number',
						selectedAccount.ACCOUNTNUMBER,
						selectedPriceSource.AGREEMENT_NUMBER,
						self.getZipCode(),
						decodeURI(self.props.params.searchKeyword),
						"",
						response => {
							// Check if both (prices and availability) service call are completed or not
							// add prices to availability existing object and update it in to store before redirecting to search result page
							self.props.updateAvailabilityWithPricesAndDiscounts();
							self.setState({
								onlyAvailabilityCall: false
							});
						},
						self.state.onlyAvailabilityCall
					);
				} else if (typeOfSearch === 'quote-models') {
					self.getQuotemodelsIfNotExists((searchStr) => {
						self.props.checkAndSetSearchResult(
							typeOfSearch,
							selectedAccount.ACCOUNTNUMBER,
							selectedPriceSource.AGREEMENT_NUMBER,
							self.getZipCode(),
							self.state.searchStrQuoteModels,
							"",
							response => {
								// Check if both (prices and availability) service call are completed or not
								// add prices to availability existing object and update it in to store before redirecting to search result page
								self.props.updateAvailabilityWithPricesAndDiscounts();
								self.setState({
									onlyAvailabilityCall: false
								});
							},
							self.state.onlyAvailabilityCall
						);
					});
				}
			}
		});
	}
	getQuotemodelsIfNotExists(callback) {
		const self = this;
		const { selectedPriceSource } = self.props.state.user;
		if (!self.state.searchStrQuoteModels) {
			self.props.getQuoteModels(`requestType=getQuoteModels&accountNumber=${self.props.getSelectedAccountNumber()}&salesAgreement=${selectedPriceSource.AGREEMENT_NUMBER}`, response => {
				const responseObject = JSON.parse(response.responseObject);
				const items = _.chunk(responseObject.map(item => item.item_number), 10);
				const searchStr = [];
				items.forEach(item => {
					searchStr.push(item.join(" "));
				});
				self.setState({
					searchStrQuoteModels: searchStr
				}, () => {
					callback && callback(self.state.searchStrQuoteModels);
				});
			});
		} else {
			callback && callback(self.state.searchStrQuoteModels);
		}
	}
	toggleFilters = e => {
		e.preventDefault();
		this.setState({
			showFilters: !this.state.showFilters
		})
  	};

	// use options to keep a backup of items/availability/prices data in the store
	fetchProductLineSearchResult(navigationState, typeOfSearch, options = { updateBackup: { items: false, availability: false, prices: false } }) {
        const self = this;
        const { selectedAccount, selectedPriceSource } = self.props.state.user;

		self.props.checkAndSetSearchResult(
			typeOfSearch,
			selectedAccount.ACCOUNTNUMBER,
			selectedPriceSource.AGREEMENT_NUMBER,
			self.getZipCode(),
			"",
			navigationState,
			response => {
				// Check if both (prices and availability) service call are completed or not
				// add prices to availability existing object and update it in to store before redirecting to search result page
				self.props.updateAvailabilityWithPricesAndDiscounts(options);

				//get filters if product line is the type of search,
				//filter will be get once after getting actual available products only
				//Prepare list of sku list of available products
				const items = typeOfSearch === 'product-line' ? self.props.state.product.productResultAvailabilityBackup : self.props.state.product.productResultAvailability;
				const skuList = [];
				items.forEach((item, index) => {
					skuList.push({
						"sku": item.sku
					});
				});
				if(self.state.narrowFilterChanged) {
					self.setState({
						narrowFilterChanged: false,
					});
				}
				if(self.state.checkboxFilterChecked) {
					self.props.fireGTMTag('Postlogin Search Result Filter', {
						filterCategory: self.state.selectedNarrowYourResultLabel,
						filterTerm: self.state.checkboxFilterChecked,
						filterResults: self.props.state.product.productResultAvailability.length
					});
				} else {
					self.props.fireGTMTag('Postlogin Search Result Filter', {
						filterCategory: self.props.state.product.productLine.label,
						filterTerm: self.state.selectedNarrowYourResultLabel,
						filterResults: self.props.state.product.productResultAvailability.length
					});
				}
				skuList.length > 0 && self.props.getProductLineFilters(skuList, navigationState.replace("?", ""));
			}
		);
    }

	handleFilterCheck(displayName, filterName, navigationState, event) {
			const self = this;
			let { product } = self.props.state;
			let{ productLine } = self.props.state.product;
			let isChecked =event.target.checked;
			if (!isChecked && displayName !== "CustomerNet" && product && product.productLineFilters) {
				const navSet = new Set(navigationState.replace('?N=', '').split('+'));

				const customerNetFilter = product.productLineFilters.filters.find(
					(filter) => filter.displayName === "CustomerNet"
				);

				if (customerNetFilter && Array.isArray(customerNetFilter.values)) {
					customerNetFilter.values.forEach((value) => {
					if (value.checked === true && value.dimensionId) {
						const dimParts = value.dimensionId.replace('?N=', '').split('+');
						dimParts.forEach(part => {
							if (!navSet.has(part)) {
								navSet.add(part);
							}
						});
					}
					});
				}
				navigationState = `?N=${Array.from(navSet).join('+')}`;
			}
			if (!isChecked && displayName ==='CustomerNet' && !navigationState.startsWith(productLine.navigationState)) {
				let cleanNav = navigationState.replace('?N=', '');
				let cleanProductNav = productLine.navigationState.replace('?N=', '');
				navigationState = `?N=${cleanProductNav}+${cleanNav}`;
			}
			if(product && product.productLineFilters) {
				var original = product.productLineFilters;
				original.filters.map((item, index) => {
					if(item.displayName === displayName) {
						item.values.map((itm, ind) => {
							if(itm.value === filterName) {
								itm.checked = event.target.checked;
							}
							return null;
						});
					}
					return null;
				});
				product.productLineFilters = original;
			}
			if(!isChecked){
				const filterId = product.productLineFilters.selectedFilters.find(selectedFilter => selectedFilter.name === filterName).id.toString();
				navigationState = '?N=' + navigationState.replace('?N=', '').split('+').filter(id => id !== filterId).join('+');
			}
			self.setState({
				checkboxFilterChecked: isChecked ? filterName : null,
			}, () => {
				self.fetchProductLineSearchResult(navigationState, self.state.typeOfSearch);
			});
		}

    clearAllFilters(event) {
		event.preventDefault();
        const self = this,
			{ productLine } = self.props.state.product;

		self.setState({
			selectedNarrowYourResult: productLine.navigationState,
			hideNarrowByFilters: true,
			checkboxFilterChecked: null,
		});

		//Clear filter first time once user comes first on this page after searching from login page
		self.props.saveProductLineFilters(null);
		//Reset List first then new values will be added
		self.props.resetProductNumberKeywordResultList();

        this.fetchProductLineSearchResult(productLine.navigationState, this.state.typeOfSearch, { updateBackup: { items: true, availability: true, prices: true } });
    }

	handleSelectAvail(e){
		this.setState({
		   filteredAvailQty: e.target.checked ? true:false
		})
   }

   handleExcludeNla(e){
	this.setState({
		filterNLA :e.target.checked? true :false
	})
}

    render() {
        var self = this,
            narrowByFilters = [];
		const isPunchOutAccess = self.props.isPunchOutAccess()
        const { state } = self.props,
			{ userDetails, selectedAccount } = state.user;
        let { resultLoaded, productResultAvailability } = state.product;
		if(state.product.productLineFilters && !_.isEmpty(state.product.productLineFilters.filters)) {
			narrowByFilters = state.product.productLineFilters.filters
        }
		if(self.state.filteredAvailQty){
			productResultAvailability = resultLoaded &&	productResultAvailability && productResultAvailability.filter(avail=> {
		 	return avail.availableQty>0
		 	});
		 }
		 if(self.state.filterNLA){
			let { productNumberKeywordResult } = self.props.state.product; 
			productResultAvailability =  resultLoaded && productResultAvailability && productResultAvailability.length > 0 && productResultAvailability.filter((item, index) => {
			   let lifeCyclePhaseValueMultipleValues =productNumberKeywordResult && productNumberKeywordResult.filter(itm => itm.sku === item.sku);
			   let lifeCyclePhaseValue = lifeCyclePhaseValueMultipleValues && lifeCyclePhaseValueMultipleValues.length > 0 ? lifeCyclePhaseValueMultipleValues[0].lifeCyclePhase : null;
			   if(!(self.props.checkIfFP(item) || lifeCyclePhaseValue === "Near End of Life")){
				   return item
			   }
			});
		}
    	return (
            <div>
               	<p><b>{this.state.errorMessage}</b></p>
				<h1>
					{this.state.typeOfSearch==='product-line'?_.unescape(state.product.productLine.label):null}
					{this.state.typeOfSearch==='quote-models'?'Quote Models':null}
				</h1>
                <h2 className={this.state.typeOfSearch==='product-number'?"":"hide"}>
					<span style={{fontWeight: 'normal'}}>You searched:</span>&nbsp;
					{self.props.params.searchKeyword?self.props.params.searchKeyword.replace(/ /g, ', ').toUpperCase():''}
				</h2>
               	{/*<p>
                  	<b>Results shown are for:</b> &nbsp; &nbsp; Account # {selectedAccount.ACCOUNTNUMBER} &nbsp;&nbsp; {selectedADC === defaultSelectedADC ? <span>Zip Code {self.props.getZipCode()}</span> : <span>ADC : {selectedADC}</span>}
               	</p>*/}
				<ChangeZipCode
					saveCustomADC={self.props.saveCustomADC}
					customADC={self.props.customADC}
					selectedAccount={selectedAccount}
					getShippingAddressesDetails={this.props.getShippingAddressesDetails}
					acceptNumbersOnly={this.props.acceptNumbersOnly}
					handleSelectZipCode={this.props.saveCustomZipCode}
					accountNumber={this.props.getSelectedAccountNumber()}
					zipCode={this.props.customZipCode}
					typeOfAccount={self.props.getSelectedAccountType()}
					handleSelectAvail={this.handleSelectAvail.bind(this)}
					handleExcludeNla={this.handleExcludeNla.bind(this)}
					filteredAvailQty ={this.state.filteredAvailQty}	
					filterNLA ={this.state.filterNLA}	
					showInStockFilter={true}
					showExcludeNlaFilter={true}
				/>
				{this.state.typeOfSearch === 'product-line'
                 	?<div>
                     	<h2 className="blue">
                         	<span className="withIcon withFilterIcon">
								 <a href="#" onClick={this.toggleFilters} >
									Narrow Your Results (optional)</a>
							</span>
                     	</h2>
                        <div id="narrowBy" className={"narrowBy "+(this.state.showFilters?"":"hide")}>
                            <div className="narrowBy_inner1">
                               	<div className="narrowBy_inner2">
                                  	<div className="narrowBy_inner3">
                                     	<div className="narrowBy_inner4">
	                                        <div className="heading">
	                                           <h2>Narrow By <span className="unbold">(Optional)</span></h2>
	                                           <p className="clearAllParagraph"><a href="" onClick={this.clearAllFilters.bind(this)}>Clear All</a></p>
	                                        </div>
                                        	<div id="filtersContainer">
                                             	{narrowByFilters && narrowByFilters.map((item, index) => {
                                                 	return <div className="filterBox" key={index}>
                                                    	<div className="filterBox_inner">
                                                       		<div className="filterBox_inner2" style={{overflow: 'hidden'}}>
                                                          		<h3 className="filterHeading" alt={item.displayName.toUpperCase()} title={item.displayName.toUpperCase()}>{item.displayName==='CustomerNet'?'Product Line':item.displayName}</h3>
                                                          		<div className="checkboxContainer">
                                                             		{item.values.map((itm, ind) => {
                                                                 		return <div key={ind} className={"checkboxDiv "+(itm.disable?'disabledCheckboxDiv':'')}>
																																			<input type="checkbox" checked={item.displayName === "Product Line"? this.state.selectedNarrowYourResult === itm.dimensionId : (itm.checked || false)}
																																			className="checkbox" disabled={!itm.disable?false:true} onChange={self.handleFilterCheck.bind(this, item.displayName, itm.value, itm.dimensionId)} 
																																			id={"checkbox_"+index+"_"+ind} defaultValue={itm.dimensionId} />
																																			<label htmlFor={"checkbox_"+index+"_"+ind} style={{cursor: 'pointer'}}>{itm.value}</label>
                                                                 		</div>
                                                             		})}
                                                          		</div>
                                                       		</div>
                                                		</div>
                                                 	</div>
                                             	})}
                                           		<div style={{clear: 'both'}}></div>
                                        	</div>
                                       		<div style={{clear: 'both'}}></div>
                                     	</div>
                                  	</div>
                               	</div>
                            </div>
                     	</div>
                    </div>
                :null}
				{resultLoaded && productResultAvailability && productResultAvailability.length > 0 && !isPunchOutAccess
					?<p className="textRight">
						<a className="withIcon withExportIcon noUnderline uppercase bold" href="" onClick={this.handleDialogStatus.bind(this, true)}>Export Product / Price Info</a>
					</p>
					:null
				}
				{((this.props.state.user.localUserDetails || userDetails.typeOfUser === 'employee') && this.state.showExportProductPriceDialog)
					?<ExportProductPriceInfoOverlayDialog
						getOrgAttributesByAttributeName={this.props.getOrgAttributesByAttributeName}
						isAccessToMAPGuidelines={this.props.isAccessToMAPGuidelines}
						getZipCode={this.getZipCode}
						
						typeOfSearch={this.state.typeOfSearch}
						searchKeyword={this.props.params.searchKeyword}
						isPricingAccess={this.props.isResponsibilityExists("Price")}
						isPriceDiscountAccess={this.props.isResponsibilityExists("Price Discounts")}
						handleDialogStatusExport={this.handleDialogStatusExport.bind(this)}
						showDialog={true}
						getShippingAddressesDetails={this.props.getShippingAddressesDetails}
						typeOfAccount={this.props.getSelectedAccountType()}
						customADC={this.props.customADC}
					/>
					:null
				}
            	{(this.props.state.user.localUserDetails || userDetails.typeOfUser === 'employee') && <ProductSearchResult
					checkIfFP={this.props.checkIfFP}
					selectedNarrowYourResult={this.state.selectedNarrowYourResult}
					validateFDD={this.props.validateFDD}
					getShippingAddressesDetails={this.props.getShippingAddressesDetails}
					isResponsibilityExists={this.props.isResponsibilityExists}
					getZipCode={this.getZipCode}
					searchKeyword={this.props.params.searchKeyword}
					customerType={self.props.getSelectedAccountType()}
					dispatch={self.props.dispatch}
					productResultAvailability={productResultAvailability}
					typeOfSearch={this.state.typeOfSearch}
					accountNumber={this.props.getSelectedAccountNumber()}
					formatETADate={this.props.formatETADate}
					fireGTMTag={this.props.fireGTMTag}
					checkAvailabilityGeneric={this.props.checkAvailabilityGeneric}
					getSalesAgreementParamForAvailability={this.props.getSalesAgreementParamForAvailability}
				/>}
				{this.state.showSuccessPriceTemplateConfirmation?<SuccessPriceTemplateConfirmation saveTemplateOrNot={false} handleDialogStatus={this.handleDialogStatusRunExportConfirm.bind(this)} showDialog={true} />:null}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	saveNarrowYourResultSelectedValue: (data) => dispatch(saveNarrowYourResultSelectedValue(data)),
	saveProductLineFilters: (data) => dispatch(saveProductLineFilters(data)),
	resetProductNumberKeywordResultList: () => dispatch(resetProductNumberKeywordResultList()),
	saveProductLine: (data) => dispatch(saveProductLine(data)),
	saveProductLineNarrowYourResultsFilters: (data) => dispatch(saveProductLineNarrowYourResultsFilters(data)),
	resetProductAvailabilityResultList: () => dispatch(resetProductAvailabilityResultList()),
	resetProductPricesResultList: () => dispatch(resetProductPricesResultList()),
	getProductLineNarrorYourResultFilters: (payload) => dispatch(getProductLineNarrorYourResultFilters(payload)),
	updateAvailabilityWithPricesAndDiscounts: (data) => dispatch(updateAvailabilityWithPricesAndDiscounts(data)),
	getQuoteModels: (queryStringParams, callback) => dispatch(getQuoteModels(queryStringParams, callback)),
	getProductLineFilters: (payload, hybridQueryParams, callback) => dispatch(getProductLineFilters(payload, hybridQueryParams, callback)),
});

SearchResult = connect(mapStateToProps, mapDispatchToProps)(SearchResult);
export default SearchResult;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/SearchResult/index.js